
































































































































































































































import { Component } from 'vue-property-decorator';
import i18n from '@/services/i18n';
import { SingleBudgetProgramField } from '../budget-programs';
import { SingleBudgetVariantField } from '../budget-variants';
import * as common from '../common';
import { ComponentBase, Overlay, SvgIcon } from '../components';
import { BudgetVariants, Utils, Dict, Org, Report2, Version } from '../types';
import { SingleVersionField } from '../versions';
import axios from "axios";
import TemplateKey = Utils.TemplateKey;
import {generateExpression} from "@/modules/budget/staffing-table/reports/templates/expressionHelper";
import {staffTabAccess} from "../common";
import CurYearField from "@/modules/budget/staffing-table/components/CurYearField.vue";
import ConfirmModal from "@/modules/budget/staffing-table/components/ConfirmModal.vue";
import {SingleOrgField} from "@/modules/budget/staffing-table/organizations";
import GenerateReport from "@/modules/budget/staffing-table/reports/GenerateReport.vue";
import type {BoolEx} from "@/modules/budget/staffing-table/reports/types";
import GenerateStaffTabReport from "@/modules/budget/staffing-table/reports/GenerateStaffTabReport.vue";
import GenerateFzpReport from "@/modules/budget/staffing-table/reports/GenerateFzpReport.vue";
import * as reportsCommon from './common';

const events = {
    /**
     * пример слушателя - onFzpReportSaved(id: number)
     */
    fzpReportSaved: 'fzp-report-saved',
    reportSaved: 'report-saved',
};

const formGroupStyle = {
    margin: '8px 8px',
    minWidth: '300px',
    display: 'block',
};

const translates = {
    tools: {
        buttons: {
            get clearBudgetProg(): string {
                return i18n.choose(
                    'Сбросить бюджетную программу',
                    'Сбросить бюджетную программу (каз)',
                    'Reset Budget Program',
                );
            },
            get staffTabReportForm(): string {
                return i18n.choose(
                    'Отчеты по формам',
                    'Отчеты по формам (каз)',
                    'Report forms',
                );
            },
            get staffingTableReports(): string {
                return i18n.choose(
                    'Отчеты штатного расписания',
                    'Отчеты штатного расписания (каз)',
                    'staffingTableReport',
                );
            },
            get fzpReports(): string {
                return i18n.choose(
                    'Отчеты по ФЗП',
                    'ФЗП туралы есептер',
                    'Reports on FZP',
                );
            },
        }
    },
    errors: {
        get cannotLoadBudgetSubprograms(): string {
            return i18n.choose(
                'Cannot load budget subprograms',
                'Не удалось загрузить бюджетные подпрограммы (каз)',
                'Не удалось загрузить бюджетные подпрограммы',
            );
        },
    },
    fields: {
        budgetSubprogram: {
            get title(): string {
                return i18n.choose(
                    'Бюджетная подпрограмма',
                    'Бюджетная подпрограмма (каз)',
                    'Budget subprogram',
                );
            },
            get emptyValue(): string {
                return i18n.choose(
                    '[ Нет значения ]',
                    '[ Нет значения ] (каз)',
                    '[ No value ]',
                );
            },
        },
    },
};

@Component({
    components: {
        ConfirmModal,
        Overlay,
        SingleBudgetProgramField,
        SingleBudgetVariantField,
        SingleOrgField,
        SingleVersionField,
        SvgIcon,
        CurYearField,
        GenerateReport,
        GenerateStaffTabReport,
        GenerateFzpReport,
    },
})
export default class GenerationPaneBase extends ComponentBase {
    constructor() {
        super('modules.budget.staffing_table.reports.*XlsxGenerationPane*');
    }

    // region Lifecycle
    protected created() {
        super.created();

        if (reportsCommon.reportRuntimeContext.shownReportType === 'FZP') {
            this.tabIndex = 2;
        }

        this.reportYearString = this.reportYear.toString();

        // region Данные
        this.$watch('org', (org: Org | null) => {
            common.store.org = org;
            common.store.conditionExp = null
            this.ebkFunc = common.store.abp;
            this.resetVersion()
            this.resetBudgetProgram()
            this.resetBudgetVariant()
        });
        this.$watch('requiredRegionCode', (/* requiredRegionCode: string | null */) => {
            this.reloadRegion();
        });
        this.$watch('version', (version: Version | null) => {
            common.store.version = version;
            if (!this.reportYearIsChanged) {
                this.upDateConditionExp();
            }
        });
        this.$watch('reportYear', async (reportYear: number) => {
            this.reportYearIsChanged = true
            common.store.reportYear = reportYear;
            common.store.conditionExp = null
            await this.updateBudgetVariant(this.org)
            await this.loadInitialBudgetProgram();
            this.upDateConditionExp();
            this.reportYearIsChanged = false

        });
        this.$watch('reportYearString', (/* reportYearString: string */) => {
            this.readReportYearString();
            this.resetBudgetVariant();
        });
        this.$watch('budgetVariant', (budgetVariant: BudgetVariants | null) => {
            common.store.budgetVariant = budgetVariant;
            if (budgetVariant) {
                if (!this.reportYearIsChanged) {
                    this.upDateConditionExp();
                }
            }
        });

        this.$watch('budgetProgram', (budgetProgram: Dict.EbkFunc | null) => {
            common.store.budgetProgram = budgetProgram;
            if (!this.reportYearIsChanged && this.templateKeyIsBudgetProgram) {
                this.upDateConditionExp();
            }
        });
    }
    // endregion

    protected mounted() {
        super.mounted();
        this.reloadRegion();
        this.loadInitialBudgetProgram();
    }

    // region Утилиты
    public translates = translates;

    public formGroupStyle = formGroupStyle

    private tabIndex: number = 0;

    // region Активный шаблон запроса
    templateKey = common.store.templateKey

    get templateKeyIsBudgetProgram(): boolean {
        return  this.templateKey === 'budget-program-reports'
    }

    // Доступ к редактированию данных
    get isEditable(): boolean {
        return staffTabAccess.isEditable;
    }

    get isFzpAccessible(): boolean {
        if (common.debugUtilObject.get(common.debugUtilKeys.reports.fzp.accessible) === true) {
            return true;
        }

        /*
        https://plane.smartderek.kz/main/browse/EAK-64/
        [Ошибка] 1. Отчет не доступен пользователям с ролями Консультант/Техподдержка
        Т.е. отчет должен быть доступен пользователям с ролями Консультант/Техподдержка

        Используется функционал, сделанный в рамках задачи https://plane.smartderek.kz/main/browse/EAK-101
         */
        if (common.staffTabAccess.isTechSupport || common.staffTabAccess.isConsultant) {
            return true;
        }

        // Нужно давать доступ для "Пользователь, у которого в Месте работы ГУ указан ГУ с org_attribute in ('1', '2') и признак "Сводящий""

        const applicableWorkplace = staffTabAccess.workplaceInfoList
            .find((wp) => {
                return (
                    (
                        /* ГУ с org_attribute in ('1', '2') */
                        (wp.gu.orgAttribute === '1')
                        ||
                        (wp.gu.orgAttribute === '2')
                    )
                    &&
                    (wp.link.lead === true /* признак "Сводящий" */)
                );
            });

        return (applicableWorkplace !== undefined);
    }

    get staffTabVersionId(): number | null {
      return this.version?.id ?? null
    }

    get getVariant(): BudgetVariants | null {
        return this.budgetVariant
    }

    get getBudgetProgram(): Dict.EbkFunc | null {
        return this.budgetProgram ?? null
    }

    public onReportSaved(report: Report2) {
        this.$emit(events.reportSaved, report);
    }

    public upDateConditionExp() {
        const conditionExp = generateExpression(this.templateKey)
        if (conditionExp != null) {
            this.$emit('update-condition', conditionExp, this.templateKey);
        }
    }

    public upDateConditionExpToParent(conditionExp: BoolEx.Expression<boolean> | null, templateKey: TemplateKey) {
        if (conditionExp != null) {
            this.$emit('update-condition', conditionExp, templateKey);
        }
    }

    // region Версия
    public version: Version | null = common.store.version;
    private resetVersion() {
        this.version = null
    }

    // region АБП
    public ebkFunc: Dict.EbkFunc | null = common.store.abp;
    public get abpCode(): number | null {
        const guCode = this.gu?.code ?? null;

        if (guCode === null) {
            return null;
        }
        if (guCode.length < 3) {
            return null;
        }

        const abpCodeString = guCode.substring(0, 3);
        const abpCode = parseInt(abpCodeString);

        if (String(abpCode) !== abpCodeString) {
            console.error(`GU code "${guCode}" contains invalid ABP code "${abpCodeString}"`);
            return null;
        }
        return abpCode;
    }

    // region Регион
    public regionLoading = false;
    public region: Dict.BudgetRegions | null = null;

    public get regionCode(): string | null {
        const region = this.region;
        if (region === null) {
            return null;
        }
        return region.code;
    }

    public get regionText(): string | null {
        const region = this.region;
        if (region === null) {
            return null;
        }

        const title = this.localize(
            () => (region.nameRu ?? region.code ?? region.id?.toString() ?? ''),
            () => (region.nameKk ?? region.nameRu ?? region.code ?? region.id?.toString() ?? ''),
            () => (region.nameRu ?? region.code ?? region.id?.toString() ?? ''),
        );

        const code = (region.code ?? region.id?.toString() ?? '');

        return `${code} - ${title}`;
    }

    public get requiredRegionCode(): string | null {
        const gu =  this.gu;
        if (gu === null) return null;

        let result: string;
        if (gu.budgetType === '02') {
            const idRegion = gu.idRegion;
            const idRegionPart = (
                idRegion.length > 2 ?
                    idRegion.substr(0, 2)
                    :
                    idRegion
            );
            result = idRegionPart + '0101';
        } else {
            result = gu.idRegion;
        }

        return result;
    }

    public reloadRegion() {
        if (this.regionLoading) {
            console.error('Cannot reload region - another loading is running');
            return;
        }

        const requiredRegionCode = this.requiredRegionCode;
        if (requiredRegionCode === null) {
            console.error('Cannot load region - required region code is null');
            return;
        }

        this.regionLoading = true;
        this.region = null;
        this.request<Dict.BudgetRegions | null>(
            { url: `/api/budget/staffing_table/budget-regions/by-code/${requiredRegionCode}` },
            (data) => {
                this.region = data;
            },
            'Error while loading region',
            () => {
                this.regionLoading = false;
            },
        )
    }
    // endregion

    // region Организация, ГУ, КГКП, АБП
    public org: Org | null = common.store.org;

    public get kgkp(): Dict.GuKgkp | null {
        const org = this.org;
        if ((org === null) || (org.type !== 'KGKP')) {
            return null;
        }
        return org.kgkp;
    }

    public get gu(): Dict.Gu | null {
        const org = this.org;
        if (org === null) {
            return null;
        }

        const type = org.type;
        switch (org.type) {
            case 'KGKP':
                return org.gu;
            case 'GU':
                return org.gu;
            default:
                console.error(`Unexpected org type \"${type}\"`);
                return null;
        }
    }

    // region Год отчета
    public reportYear: number = Number(common.store.reportYear)
    public reportYearString: string = '';
    public reportYearIsChanged = false

    onReportYearChange(value: number) {
        this.reportYearString = value.toString();
    }

    public readReportYearString() {
        try {
            const number = parseInt(this.reportYearString);
            if (!Number.isSafeInteger(number)) {
                return;
            }
            if (number.toString(10) !== this.reportYearString.trim()) {
                return;
            }
            this.reportYear = number;
        } catch (e) {}
    }

    public get year(): number | null {
        const version = this.version;
        if (version === null) {
            return null;
        } else {
            return version.year;
        }
    }
    // endregion

    // region Версия бюджета
    public budgetVariantLoading = false;
    public budgetVariant: BudgetVariants | null = common.store.budgetVariant;

    onUpdateVariant() {
        this.updateBudgetVariant(this.org)
    }

    async updateBudgetVariant(org: Org | null) {
        this.budgetVariant = org ? (await this.setActualVariant()) ?? null : null;
    }

    async setActualVariant(): Promise<BudgetVariants | null> {
        this.budgetVariantLoading = true;
        const initialBudgetVariant = common.store.budgetVariant;

        const orgCode = this.org?.org.code;
        const year = this.reportYear
        const url = this.prepareUrl(
            '/api/budget/staffing_table/budget-variants/by-org-active-date',
            [
                ['org-code', orgCode],
                ['year', year],
            ],
        );
        try {
            const response = await axios.get<Array<BudgetVariants>>(url);
            if (initialBudgetVariant != null) {
                const index = response.data.findIndex((budgetVariant) => budgetVariant.id === initialBudgetVariant.id);
                if (index >= 0) {
                    return initialBudgetVariant;
                }
            }

            return response.data.find(variant => variant.attribute) ?? response.data[0] ?? null;

        } catch (error) {
            console.error(`Error retrieving the actual variant for the year ${year}:`, error);
            return null;
        }
        finally {
            this.budgetVariantLoading = false;
        }
    }

    private resetBudgetVariant() {
        this.budgetVariant = null
    }
    // endregion

    // region Бюджетная программа
    public budgetProgramLoading = false;
    public budgetProgram: Dict.EbkFunc | null = common.store.budgetProgram;
    public budgetProgramInitCancelled = false;

    private resetBudgetProgram() {
        this.budgetProgram = null
    }

    public async loadInitialBudgetProgram() {
        const initialBudgetProgram = common.store.budgetProgram;
        if (initialBudgetProgram === null) {
            return;
        }

        if (this.budgetProgramLoading) {
            console.error('Cannot load initial budget program - another loading is running');
            return;
        }

        const reportYear = this.reportYear;
        const abpCode = this.abpCode;
        if (abpCode === null) {
            console.error('Cannot load initial budget program - ABP code is null');
            return;
        }

        this.budgetProgramLoading = true;

        const url = this.prepareUrl(
            `/api/budget/staffing_table/budget-programs`,
            [
                ['abp-code', abpCode],
                ['year', reportYear],
            ]
        );

        try {
            const data = await axios.get<Array<Dict.EbkFunc>>(url);

            if (this.budgetProgramInitCancelled) {
                return;
            }

            const index = data.data.findIndex((budgetProgram) => budgetProgram.id === initialBudgetProgram.id);
            if (index >= 0) {
                this.budgetProgram = initialBudgetProgram;
            } else {
                this.budgetProgram = null
            }
        } catch (error) {
            this.toast(
                'danger',
                this.i18n.translate('errors.cannot_load_budget_programs'),
                error.toString(),
            );
        } finally {
            this.budgetProgramLoading = false;
        }
    }
    // endregion

    public formReportLoading = false;

    // region Общие данные
    public get loading(): boolean {
        return (this.regionLoading || this.budgetVariantLoading || this.budgetProgramLoading || this.formReportLoading);
    }

    public onFzpReportSaved(id: number) {
        this.$emit(events.fzpReportSaved, id);
    }
}
